import Routings from "./Routings";

export default function MainContent() {
    return <main>
        <div className="container-fluid px-4">
            <Routings />
        </div>
    </main>
}